import { render } from "./HistoryChip.vue?vue&type=template&id=6f72cbf5&scoped=true"
import script from "./HistoryChip.vue?vue&type=script&lang=js"
export * from "./HistoryChip.vue?vue&type=script&lang=js"

import "./HistoryChip.vue?vue&type=style&index=0&id=6f72cbf5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f72cbf5"]])

export default __exports__